import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { SAMService } from '../sam/sam.service';
import { SAMMessage } from '../sam/interfaces/sam-message';
import { DeviceType } from '../base/device-type.enum';

@Injectable({
  providedIn: 'root'
})
export class SpeechService {

  synth: SpeechSynthesis = window.speechSynthesis;
  voices: Array<SpeechSynthesisVoice> = [];
  currentVoice: SpeechSynthesisVoice;

  // Alice = it-IT
  // Luca = it-IT

  constructor(
    private sam: SAMService,
    private configSvc: ConfigService,
  ) {
    
  }

  setVoice(lang) {
    this.voices = this.synth.getVoices();
    this.voices.forEach( (voice: SpeechSynthesisVoice) => {
      if (voice.lang === lang && voice.name.indexOf('Google') !== -1 && voice.localService === false) {
        this.currentVoice = voice;
      } else if (voice.lang === lang && voice.localService === true) {
        this.currentVoice = voice;
      }
    });
  }

  say(message: string) {
    if (this.configSvc.deviceType === DeviceType.RESTAURANT) { return; }
    if (this.configSvc.guiSettings.enableSpeech === false) { return; }
    if (this.synth.speaking) { return; }
    if (message) {
      this.setVoice('it-IT');
      const utterThis = new SpeechSynthesisUtterance(message);
      utterThis.voice = this.currentVoice;
      utterThis.pitch = 1.1;
      utterThis.rate = 1.1;
      this.synth.speak(utterThis);
    }
  }

  clean(msg) {
    msg = msg.replace(/a'/gi, 'à');
    msg = msg.replace(/e'/gi, 'è');
    msg = msg.replace(/i'/gi, 'ì');
    msg = msg.replace(/o'/gi, 'ò');
    msg = msg.replace(/u'/gi, 'ù');
    return msg;
  }

  subscribeListeners() {
    this.sam.channels.audio.subscribe((msg: SAMMessage) => {
      if (['TEXT_TO_SPEECH'].includes(msg.Command)) {
        setTimeout(() => {
          this.say(msg.parms.Text);
        }, 100);
      }
    });
  }
}
